import React from 'react';
import './page-loader.css';

/**
 * Full-page loading state for route/Suspense fallbacks: a single spinning
 * icon centered on the page. Replaces the old spinning "Loading…" text (whose
 * whole box, text included, spun once teams-list/action-log CSS redefined
 * `.loading-spinner` with an element-level `spin` animation).
 */
const PageLoader: React.FC = () => (
  <div className="page-loader" role="status" aria-label="Loading">
    <span className="page-loader-spinner" />
  </div>
);

export default PageLoader;
